var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn_delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onButtonClick($event)}}},[_vm._v(_vm._s(_vm.$t('delete')))])}
var staticRenderFns = []

export { render, staticRenderFns }